import { engine } from "../..";
import { getSuggestionsArgsParams } from "./getSuggestionsArgsParams";
import { BatchSuggestionArgsOptions } from "./initSuggestionArgs";

export function initSmartControlValvesSuggestionArgs({
  filters,
  ...valveSuggestionArgs
}: BatchSuggestionArgsOptions) {
  const { cleanup, params } = getSuggestionsArgsParams({
    filters,
    ...valveSuggestionArgs,
  });
  const args = new engine.BatchSelectionSmartControlValvesArgs(...params);

  return {
    cleanup() {
      cleanup();
      args.delete();
    },
    suggestionArgs: args,
  };
}
